<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Contents">
<p class="h2"><span class="right_1" epub:type="pagebreak" id="page_vii" title="vii"><b>CONTENTS</b></span></p>
<p class="toc-fm" id="ack"><a href="#/text/00a_Marsh_fm_prod1"><i>Acknowledgments</i></a></p>
<p class="toc_ct" id="int"><a href="#/text/00b_Marsh_introduction_prod">Introduction: <i>Différance</i>. Otherness. Experiment.</a></p>
<p class="toc" id="ch1"><a href="#/text/01_Marsh_ch1_prod">1<span class="space">Interrogations of the National Allegory: Trance Film and Ethnography</span></a></p>
<p class="toc" id="ch2"><span href="#/text/02_Marsh_ch2_prod" title="Link target outside of Sample">2<span class="space">Intermediality, Intoxication, and the <i>Infrathin</i></span></span></p>
<p class="toc" id="ch3"><span href="#/text/03_Marsh_ch3_prod" title="Link target outside of Sample">3<span class="space">The Discontinuous Legacies of Pere Portabella: Between Heritage and Inheritance</span></span></p>
<p class="toc" id="ch4"><span href="#/text/04_Marsh_ch4_prod" title="Link target outside of Sample">4<span class="space">History, Hauntology, Representation: Spanish Cinema against Itself</span></span></p>
<p class="toc" id="ch5"><span href="#/text/05_Marsh_ch5_prod" title="Link target outside of Sample">5<span class="space">The <i>Ex</i> of Experimentation: Against Periodization</span></span></p>
<p class="toc" id="ch6"><span href="#/text/06_Marsh_ch6_prod" title="Link target outside of Sample">6<span class="space">The Catacoustic and the Cosmopolitan: Rhythm and Timbre in the Films of Andrés Duque</span></span></p>
<p class="toc" id="ch7"><span href="#/text/07_Marsh_ch7_prod" title="Link target outside of Sample">7<span class="space">Turns and Returns, <i>Envois</i>/<i>Renvois</i>: The Postal Effect in Recent Spanish Film</span></span></p>
<p class="toc" id="ch8"><span href="#/text/08_Marsh_ch8_prod" title="Link target outside of Sample">8<span class="space">Retrospective Future Perfect: History, Black Holes, and Time Warps in the Films of Los Hijos and Luis López Carrasco</span></span></p>
<p class="toc" id="ch9"><span class="right_1" epub:type="pagebreak" id="page_viii" title="viii"><span href="#/text/09_Marsh_ch9_prod" title="Link target outside of Sample">9<span class="space"><i>¡No nos representan!</i> : Performativity as Militant Film, the 15-M Archive</span></span></span></p>
<p class="toc_ctn" id="aft"><span href="#/text/10_Marsh_afterword_prod" title="Link target outside of Sample">Afterword: Unruly Archives. <i>La décima carta</i> and <i>Buenas noches, España</i></span></p>
<p class="toc_bmht" id="bib"><span href="#/text/11_Marsh_bibliography_prod" title="Link target outside of Sample"><i>Bibliography</i></span></p>
<p class="toc_ctn" id="ind"><span href="#/text/12_Marsh_Index" title="Link target outside of Sample"><i>Index</i></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?69a72e49